import moment from 'moment';

if($('#component-application-documents').length){
    var app = new Vue({
        el: '#component-application-documents',
        data: {
            file: null,
            files: [],
            loadingFile: false,
            applicationType: applicationType,
            applicationId: applicationId,
            currentUserId: currentUserId
        },
        methods: {
            get(){
                axios.get('/api/v1/application/'+this.applicationType+'/'+this.applicationId+'/document').then((response) =>  {
                    this.files = response.data;    
                }).catch(error => {
                    this.errorHandler(error);
                });
            },
            uploadFile: function(file, bearer){

                axios.defaults.headers.common["Authorization"] = bearer;
                this.loadingFile = true;

                var fileName = file.name;

                axios.post('/api/v1/application/generate-upload-url',{
                    "file-name": file.name,
                    "file-type": file.type,
                }).then((response) => {

                    var fullPath = response.data.success['full-path'];
                    delete axios.defaults.headers.common["Authorization"];
                    axios.put(response.data.success.uri, file, {
                        headers: {
                            'Accept': 'text/plain',
                            'Content-Type': file.type
                        }
                    })
                    .then((response) => {
                        axios.defaults.headers.common["Authorization"] = bearer;
                        console.log(fullPath);

                        axios.post('/api/v1/application/'+this.applicationType+'/'+this.applicationId+'/document', {
                            "name": fileName,
                            "url": fullPath,
                            "internal": true,
                            "user_id": this.currentUserId
                        }).then((response) => {
                            this.$toasted.success('Your document has been uploaded');
                            this.get();
                            this.file = null;
                            this.loadingFile = false;
                        }).catch(error => {
                            this.errorHandler(error);
                            this.file = null;
                            this.loadingFile = false;
                        });
                    })
                    .catch(error => {
                        axios.defaults.headers.common["Authorization"] = bearer;
                        this.errorHandler(error);
                        this.file = null;
                        this.loadingFile = false;
                    });
                })
                .catch(error => {
                    this.errorHandler(error);
                    this.file = null;
                    this.loadingFile = false;
                });
            },
            handleFilesUpload(event){
                this.errors = [];
                var bearer = axios.defaults.headers.common["Authorization"];
                this.file = event.target.files[0];
                if(event.target.files && event.target.files[0]){
                    
                    if(this.file.size > 100000000){
                        this.file = null;
                        this.loadingFile = false;
                        this.$toasted.error('The file you are trying to upload is too large, it must be under 100Mb');
                    }else{
                        this.uploadFile(this.file, bearer);
                    }
                }
            },
            removeFile(id, e){
                e.stopPropagation()

                axios.delete('/api/v1/application/'+this.applicationType+'/'+this.applicationId+'/document/'+id)
                .then((response) =>  {
                    this.$toasted.success('Your document has been deleted');
                    this.get();
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            errorHandler(error){
                if(error.response && typeof error.response.data === 'string'){
                    this.$toasted.error(error.response.data);
                }else{
                    this.$toasted.error(error.response.data.message);
                }
            },
        },
        mounted() {
            this.get();
        },
    });
}